RivalIQ.apps.Insights.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    function hasSourceToken(source, widget) {
        let hasToken;
        const metadata = widget.getWidgetInstanceState();
        if (metadata) {
            hasToken = Boolean(_.get(metadata, ['sources', source, 'validToken']));
        } else {
            hasToken = true;
        }

        return hasToken;
    }

    views.NoInstagramPresencesWithInsightsView = Marionette.ItemView.mixin({
        className: 'user-action-prompt widget-insights-nothing widget-fb-insights-mapping',
        template: '#widgetInstagramInsightsNoPresenceAccessTemplate',

        ui: {
            connectedPages: '.x-view-connected-pages'
        },

        events: {
            'click @ui.connectedPages': 'openConnectedPagesModal'
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        openConnectedPagesModal: function () {
            const me = this;

            RivalIQ.execute('show:modal', new RivalIQ.apps.AccountSettings.views.ConnectedPagesModal({
                model: me.dashboardModel.getCuration(),
                source: RivalIQ.enums.sources.INSTAGRAM_INSIGHTS
            }));
        },

        serializeData: function () {
            const me = this;

            const hasToken = hasSourceToken(RivalIQ.enums.sources.INSTAGRAM_INSIGHTS, me.dashboardModel);
            const isFocusCompanyMessage = me.dashboardModel.getProp('companyId');
            return {
                hasToken: hasToken,
                errorMessage: me.getOption('errorMessage') || `You don't have access to Instagram Insights analytics for ${isFocusCompanyMessage ? 'your focus company' : 'any company in this landscape'}.`
            };
        }
    });

    views.NoFacebookPresencesWithInsightsView = Marionette.ItemView.mixin({
        className: 'user-action-prompt widget-insights-nothing widget-fb-insights-mapping',
        template: '#widgetFacebookInsightsNoPresenceAccessTemplate',

        ui: {
            connectedPages: '.x-view-connected-pages'
        },

        events: {
            'click @ui.connectedPages': 'openConnectedPagesModal'
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        openConnectedPagesModal: function () {
            const me = this;
            RivalIQ.execute('show:modal', new RivalIQ.apps.AccountSettings.views.ConnectedPagesModal({
                model: me.dashboardModel.getCuration(),
                source: RivalIQ.enums.sources.FACEBOOK
            }));
        },

        serializeData: function () {
            const me = this;

            const hasToken = hasSourceToken(RivalIQ.enums.sources.FACEBOOK, me.dashboardModel);
            const isFocusCompanyMessage = me.dashboardModel.getProp('companyId');
            return {
                hasToken: hasToken,
                errorMessage: `You don't have access to Facebook Insights analytics for ${isFocusCompanyMessage ? 'your focus company' : 'any company in this landscape'}.`
            };
        }
    });

    views.NoTwitterPresencesWithInsightsView = Marionette.ItemView.mixin({
        className: 'user-action-prompt widget-insights-nothing',
        template: '#widgetTwitterInsightsNoPresenceAccessTemplate',

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        ui: {
            manageAccounts: '.x-manage-accounts'
        },
        events: {
            'click @ui.manageAccounts': 'onManageAccounts'
        },

        onManageAccounts: function () {
            const source = RivalIQ.enums.sources.TWITTER_INSIGHTS;
            const model = RivalIQ.data.channels.get(source);
            RivalIQ.execute('show:modal', new RivalIQ.apps.AccountSettings.views.MultiTokenConnectionModal({
                model: model
            }));
        },

        serializeData: function () {
            const me = this;

            const isFocusCompanyMessage = me.dashboardModel.getProp('companyId');
            return {
                errorMessage: `You don't have Twitter Analytics connected for ${isFocusCompanyMessage ? 'your focus company' : 'any company in this landscape'}.`
            };
        }
    });

    views.NoTiktokPresencesWithInsightsView = Marionette.ItemView.mixin({
        className: 'user-action-prompt widget-insights-nothing',
        template: '#widgetTiktokInsightsNoPresenceAccessTemplate',

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        ui: {
            manageAccounts: '.x-manage-accounts'
        },
        events: {
            'click @ui.manageAccounts': 'onManageAccounts'
        },

        onManageAccounts: function () {
            const source = RivalIQ.enums.sources.TIKTOK_INSIGHTS;
            const model = RivalIQ.data.channels.get(source);
            RivalIQ.execute('show:modal', new RivalIQ.apps.AccountSettings.views.MultiTokenConnectionModal({
                model: model
            }));
        },

        serializeData: function () {
            const me = this;

            const isFocusCompanyMessage = me.dashboardModel.getProp('companyId');
            return {
                errorMessage: `You don't have TikTok Insights connected for ${isFocusCompanyMessage ? 'your focus company' : 'any company in this landscape'}.`
            };
        }
    });

    views.NoLinkedInPresencesWithInsightsView = Marionette.ItemView.mixin({
        className: 'user-action-prompt widget-insights-nothing',
        template: '#widgetLinkedInInsightsNoPresencesInLandscapeTemplate',

        events: {
            'click .x-edit-company-mapping': 'onShowEditModal'
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        serializeData: function () {
            const me = this;

            const hasToken = hasSourceToken(RivalIQ.enums.sources.LINKEDIN, me.dashboardModel);
            const isFocusCompanyMessage = me.dashboardModel.getProp('companyId');
            return {
                hasToken: hasToken,
                errorMessage: (isFocusCompanyMessage ?
                    'There is no LinkedIn Company Page connected to the focus company.' :
                    'There are no LinkedIn Company Pages connected to companies in this landscape.')
            };
        },

        onShowEditModal: function () {
            const me = this;

            const metadata = me.dashboardModel.getWidgetInstanceState();

            const accountPresences = _.map(metadata.linkedInPresences, function (company) {
                return _.extend({}, company, {
                    accountPresenceId: company.joinId,
                    companyId: company.id,
                    linked_in_presence_id: company.presenceId
                });
            });

            const allAccountPresences = _.union(accountPresences, metadata.unassociatedPresences);

            RivalIQ.execute('show:modal', new App.views.LinkedInPresenceConfigurationModal({
                accountPresences: new App.collections.LinkedInPresences(allAccountPresences),
                accountCompanies: metadata.accountCompanies,
                model: me.model
            }));
        }
    });

    views.getNoPresenceView = function (source) {
        switch (source) {
            case RivalIQ.enums.sources.INSTAGRAM_INSIGHTS:
                return views.NoInstagramPresencesWithInsightsView;

            case RivalIQ.enums.sources.FACEBOOK_INSIGHTS:
                return views.NoFacebookPresencesWithInsightsView;

            case RivalIQ.enums.sources.TWITTER_INSIGHTS:
                return views.NoTwitterPresencesWithInsightsView;

            case RivalIQ.enums.sources.TIKTOK_INSIGHTS:
                return views.NoTiktokPresencesWithInsightsView;

            case RivalIQ.enums.sources.LINKEDIN:
                return views.NoLinkedInPresencesWithInsightsView;

            default:
                throw new Error(`view not found for source ${source}.`);
        }
    };
});
